<template>
    <div>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0,minimum-scale=1.0">
        <div class="title">{{info.news_title}}</div>
        <div class="date">{{info.add_time}}</div>
        <center v-html="info.news_desc" style="padding:20px"></center>
    </div>
</template>
<script>
import { getNewsInfo} from "@/api/api"; 
export default {
    data(){
        return{
            new_id:'',
            info:{}
        }
    },
    beforeCreate() {
        document.querySelector('body').setAttribute('style', 'background:#ffffff')
    },
    // 在销毁前，将body的style属性删除
    deactivated() {
        document.querySelector('body').removeAttribute('style')
    },
    created(){
        let new_id  = this.$route.params.id
        this.new_id = new_id
        this.getList()
    },
    methods:{
        async getList(){
           const {data:res} = await getNewsInfo(this.new_id)
           this.info = res
        }
    }
}
</script>
<style scoped>
.title{
    font-size: 24px;
    font-weight: 600;
    padding-left: 20px;
    margin-top: 10px;
}
.date{
    font-size: 15px;
    font-weight: 600;
    padding-left: 20px;
    color: #818CA0;
    margin-top: 10px;
}
/deep/ img{
    width: 100% !important;
    height: 100%;
}
</style>